import axios from '@axios'

const getDefaultState = () => ({
  items: [],
  item: null,
  searchFields: '',
  orderBy: '',
  sortedBy: '',
  companyList: [],
  purposesList: [],
  regionsList: [],
  poolsList: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  },
})

export default {
  namespaced: true,
  state: getDefaultState,
  getters: {},
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_ITEM(state, payload) {
      state.item = { ...payload }
    },
    SET_COMPANIES(state, payload) {
      state.companyList = [...payload]
    },
    SET_PURPOSES(state, payload) {
      state.purposesList = [...payload]
    },
    SET_REGIONS(state, payload) {
      state.regionsList = [...payload]
    },
    SET_POOLS(state, payload) {
      state.poolsList = [...payload]
    },
    UPDATE_ITEM(state, payload) {
      state.items = state.items.map(item => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      })
    },
    SET_SEARCH_FIELDS(state, fields) {
      state.searchFields = fields
    },
    SET_ORDER_BY(state, order) {
      state.orderBy = order
    },
    SET_SORTED_BY(state, field) {
      state.sortedBy = field
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter(item => (item.id !== id))
    },
    RESET_ITEM(state) {
      state.item = null
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getItems({ commit }, { ...payload }) {
      try {
        const { data } = await axios.get('/network/nas/index', { params: { ...payload } })
        const { pagination } = data.meta

        const {
          searchFields, search, orderBy, sortedBy,
        } = payload

        if (searchFields && search) {
          commit('SET_SEARCH_FIELDS', searchFields)
        }

        if (orderBy && sortedBy) {
          commit('SET_ORDER_BY', orderBy)
          commit('SET_SORTED_BY', sortedBy)
        }

        commit('SET_ITEMS', data.data)
        commit('SET_PAGINATION', pagination)

        return data.data
      } catch (error) {
        commit('SET_ITEMS', [])
        return Promise.reject(error)
      }
    },
    async getItem({ commit }, id) {
      try {
        const { data } = await axios.get(`/network/nas/${id}/show`)
        commit('SET_ITEM', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getCompanies({ commit }, query) {
      try {
        const { data } = await axios.get(`/network/nas/companies/list?query=${query}`)
        commit('SET_COMPANIES', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getPurpose({ commit }) {
      try {
        const { data } = await axios.get('/network/nas/purposes/list')
        commit('SET_PURPOSES', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getRegions({ commit }) {
      try {
        const { data } = await axios.get('/network/nas/regions/list')
        commit('SET_REGIONS', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async getPools({ commit }) {
      try {
        const { data } = await axios.get('/network/subnet/list?usage_type=pool&type=end')
        commit('SET_POOLS', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async createItem({ commit }, payload) {
      try {
        await axios.post('/network/nas/store', {
          ...payload,
        })

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async updateItem({ commit }, { id, ...payload }) {
      try {
        await axios.put(`/network/nas/${id}/update`, {
          ...payload,
        })

        commit('UPDATE_ITEM', payload)

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async deleteItem({ commit }, id) {
      try {
        await axios.delete(`/network/nas/${id}/destroy`)

        commit('DELETE_ITEM', id)
        return true
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async recoverItem({ commit }, id) {
      try {
        await axios.put(`/network/nas/${id}/recover`)

        commit('RESET_ITEM')
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    setSearchFields({ commit }, payload) {
      commit('SET_SEARCH_FIELDS', payload)
    },

    setOrderBy({ commit }, payload) {
      commit('SET_ORDER_BY', payload)
    },
    setSortedBy({ commit }, payload) {
      commit('SET_SORTED_BY', payload)
    },
  },
}
